class MemoryStorageClass {
    constructor() {
        this._keys = [];
        this._memory = {};
    }
    isSupported() {
        return true;
    }
    get(key) {
        return this._memory.hasOwnProperty(key) ? this._memory[key] : null;
    }
    set(key, value) {
        this._memory[key] = value;
        if (this._keys.indexOf(key) < 0) {
            this._keys.push(key);
        }
        return true;
    }
    delete(key) {
        delete this._memory[key];
        const index = this._keys.indexOf(key);
        if (index < 0)
            return false;
        this._keys.splice(index, 1);
        return true;
    }
    clear() {
        // NOTE: no event support
        this._memory = {};
        this._keys = [];
        return true;
    }
}
export const MemoryStorage = new MemoryStorageClass();
